var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 0.5C26.7809 0.5 27.8183 1.53736 27.8183 2.81818V29.6772L33.1328 24.3598C34.0398 23.4557 35.506 23.4557 36.413 24.3598C37.3171 25.2669 37.3171 26.7331 36.413 27.6401L27.1492 36.9009C27.1434 36.9067 27.1347 36.9154 27.1289 36.9212L25.5004 38.5497L23.8719 36.9212C23.8661 36.9154 23.8574 36.9067 23.8516 36.9009L14.5878 27.6401C13.6836 26.7331 13.6836 25.2669 14.5878 24.3598C15.4948 23.4557 16.961 23.4557 17.868 24.3598L23.1825 29.6772V2.81818C23.1825 1.53736 24.2193 0.5 25.5001 0.5Z",
    fill: "#065E39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95455 19.5411C5.67372 19.5411 4.63636 20.5785 4.63636 21.8593V45.0412C4.63636 46.322 5.67372 47.3593 6.95455 47.3593H44.0455C45.3263 47.3593 46.3636 46.322 46.3636 45.0412V21.8593C46.3636 20.5785 45.3263 19.5411 44.0455 19.5411H34.7727C33.4919 19.5411 32.4545 18.5038 32.4545 17.223C32.4545 15.9421 33.4919 14.9048 34.7727 14.9048H44.0455C47.885 14.9048 51 18.0198 51 21.8593V45.0412C51 48.8807 47.885 51.9957 44.0455 51.9957H6.95455C3.11504 51.9957 0 48.8807 0 45.0412V21.8593C0 18.0198 3.11504 14.9048 6.95455 14.9048H16.2273C17.5081 14.9048 18.5455 15.9421 18.5455 17.223C18.5455 18.5038 17.5081 19.5411 16.2273 19.5411H6.95455Z",
    fill: "#065E39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.610ce720680310a7b4c8cba63cf3481a.svg";
export { ForwardRef as ReactComponent };